import { api } from '@/shared/api';
import type { components } from '@/shared/api/autogen/schema';
import { AxiosError } from 'axios';

type AdminDeliveryStatus = components['schemas']['AdminDeliveryStatus'];

// 変更可能なステータス（全ての配送ステータス）
export type ForceUpdateTargetStatus = AdminDeliveryStatus;

export type ForceUpdateDeliveryStatusRequest = {
    target_status: ForceUpdateTargetStatus;
};

/**
 * 配送ステータスを強制変更する
 * @param applicationId - 申し込みID
 * @param targetStatus - 変更先のステータス
 * @returns 成功時は空のレスポンス
 */
export const forceUpdateDeliveryStatus = async (
    applicationId: string,
    targetStatus: ForceUpdateTargetStatus
): Promise<void> => {
    try {
        await api.put('/applications/{application_id}/status/force', {
            path: { application_id: applicationId },
            body: { target_status: targetStatus },
        });
    } catch (error) {
        const axiosError = error as AxiosError;

        if (axiosError.status === 403) {
            throw new Error('この操作を実行する権限がありません');
        }
        if (axiosError.status === 404) {
            throw new Error('申し込みデータがありません');
        }
        if (axiosError.status === 422) {
            const data = axiosError.response?.data as { message?: string } | undefined;
            if (data?.message?.includes('完了済み')) {
                throw new Error('既にユーザー受け取り完了済みです');
            } else if (data?.message?.includes('同じステータス')) {
                throw new Error('現在のステータスと同じステータスには変更できません');
            }
            throw new Error(data?.message ?? '処理を完了できませんでした');
        }
        throw new Error('配送ステータスの変更中にエラーが発生しました');
    }
};
